<template>
  <div class="form-contact mod-global--typo-on-dark">
    <template v-if="state=='filling'">
      <!--<p class="h1">Желаете сотрудничать?</p>-->
      <!--<p class="h1">Написать сообщение</p>-->
      <p class="h1">Терминал</p>

      <form-input-wrapper
        class="name"
        :errorText=" firstErr('name')"
      >
        <form-input-text
          placeholder="Ваше Имя"
          name="name"
          v-model="values.name"
          v-validate="'required|max:255'"
          :class="{'form-input-text--has-error': firstErr('name') }"
        ></form-input-text>
      </form-input-wrapper>

      <form-input-wrapper
        class="contact"
        :errorText="firstErr('contacts')"
      >
        <form-input-text
          placeholder="Контактный E-Mail или Skype"
          name="contacts"
          v-model="values.contacts"
          v-validate="'required|max:255'"
          :class="{'form-input-text--has-error': firstErr('contacts') }"
        ></form-input-text>
      </form-input-wrapper>

      <form-input-wrapper
        errorText="Мой текст сообщения об ошибке"
        :errorText=" firstErr('message')"
      >
        <form-input-textarea
          placeholder="Текст Сообщения"
          name="message"
          v-model="values.message"
          v-validate="'required|max:1024'"
          :class="{'form-input-textarea--has-error': firstErr('message') }"
        ></form-input-textarea>
      </form-input-wrapper>

      <div class="btn-wrapper">
        <a href="" class="btn btn--accent btn--with-arrow btn--inline"
           @click.prevent = "processSubmitClick"
        >
          <!--Отправить Сообщение-->
          Отправить
        </a>
      </div>
    </template>
    <template v-if="state=='processing'">
        <cool-loader></cool-loader>
    </template>
    <template v-if="state=='success'">
      <!--див - пушо корневые элементы - флекс-итемы -->
      <div>
        <p class="h1">Сообщение отправлено</p>
        <p>Спасибо за обращение. Я свяжусь в Вами.</p>
      </div>
    </template>
    <template v-if="state=='error'">
      <div>
        <p class="h1">Ошибка</p>
        <p>Во время запроса на сервер произошла ошибка.</p>
        <p>
          Попробуйте отправить сообщение позже,
          <br>
          <!--или позвоните мне по телефону-->
          или свяжитесь со мной по телефону
          <!--<a href="tel:$SiteConfig.PhoneTech" target="hidden-iframe">$SiteConfig.PhoneVisual</a>-->
        </p>
      </div>
    </template>

  </div>

</template>

<script>
    //import comp from '@/path/to/comp.vue';    //от папки src указанной в webpack
  import formInputText from './form-input-text.vue';
  import formInputTextarea from './form-input-textarea.vue';
  import formInputWrapper from './form-input-wrapper.vue';
  import coolLoader from '../components/cool-loader-vue.vue';
  import {DateTime} from 'luxon';
  import {canSendMessage} from '../helpers/vuexFixes'

  // const { DateTime } = require('luxon');

    /**
     * @emits
     * request
     * response - нужен, например, чтобы закрыть модалку, в которой находится форма
     */
  export default {
    components: {
      formInputText,
      formInputTextarea,
      formInputWrapper,
      coolLoader,
    },
    data() {
      return {
        values: {
          name: '',
          contacts: '',
          message: ''
        },
        wasFirstSubmit: false,  //нужна чтобы не валидировать до 1-го сабмита
        state: this.getStateByTime(), // 'filling', 'processing', 'success', 'error'
      }
    },
    computed: {
    },
    methods: {
      /**
       *
       * @returns String state, один из тех что описаны в data.state
       */
      getStateByTime(){
        return canSendMessage() ? 'filling' : 'success'
      },

      //public
      processOpening(){
        this.state = this.getStateByTime();
      },

      reset(){
        for (let value in this.values) {
          if (this.values.hasOwnProperty(value)) {
            this.values[value] = undefined;
          }
        }
        this.wasFirstSubmit = false;

      },
      firstErr(name){
        return this.wasFirstSubmit ? this.errors.first(name) : ''
      },
      processSubmitClick(){
        this.wasFirstSubmit = true;
        this.$validator.validateAll().then((result) => {
          if (result) {
            this.state = 'processing'
            this.$emit('request') 

            api.post(
              'request/post',
              new URLSearchParams({
                Name: this.values.name,
                Contact: this.values.contacts,
                Message: this.values.message,
              })
            )
              .then((res)=>{
                // console.log(res)

                this.$emit('response')

                this.state = 'success';

                let currentTime = DateTime.local().toISO();
                this.$store.commit('setLastContactUsSent', currentTime)
              })
              .catch((err) => {
                console.warn(err)

                this.$emit('response')

                this.state = 'error';
              })
            return;
          }
          //не отправляем
        });
      }
    },
    mounted(){
      // console.log('mounted contact form')
    }
  }
</script>
<style scoped lang="scss">
    @import 'src/scss/vars';    //от папки со сборкой
    .form-contact {
      background-color: $clrBgDarkMore;
      color: white;
      min-height: 100%; // чтоб заполняло всю модалку
      padding: calc( 64 * var(--px)) calc( 16 * var(--px)) calc( 56 * var(--px));

      display: flex;
      flex-flow: row wrap;
      justify-content: space-between;
      > * {
        flex: 1 0 100%;
      }
      > .btn-wrapper {
        margin-top:calc( 16 * var(--px));
      }
      .form-input-wrapper {
        /*margin-bottom:calc( 8 * var(--px));*/
      }
      @media (min-width: $bp0704) {
        padding: calc( 64 * var(--px)) calc( 24 * var(--px)) calc( 56 * var(--px));
        .form-input-wrapper.name,
        .form-input-wrapper.contact {
          flex: 0 0 calc(50% - var(--sizeCell));
        }
      }
      .cool-loader {
        flex: 0 1 auto;
        margin: auto auto;
      }
    }
</style>



// WEBPACK FOOTER //
// src/components/form-contact.vue